import { MouseEventHandler } from 'react';
import { sprintf } from 'sprintf-js';

import { ApiFilestackImageData } from 'api/types/ApiFilestackImageData';
import { FilestackImage } from 'components/FilestackImage/FilestackImage';
import { TileGridVariant } from 'components/TileGrid/TileGridVariant';
import { useTabContext } from 'containers/TabContext';

import {
  TileGridBlockTileButton,
  TileGridBlockTileHeading,
  TileGridBlockTileImageContainer,
  TileGridBlockTileSubHeading,
} from './TileGridTile.styled';
import { tileGridTilePropsByVariant } from './tileGridTilePropsByVariant';

type Props = {
  id: string;
  imageData: ApiFilestackImageData;
  variant: TileGridVariant;
  heading: string;
  subHeading: string | null;
  onClick: MouseEventHandler;
};

export function TileGridTile({
  id,
  imageData,
  variant,
  heading,
  subHeading,
  onClick,
}: Props) {
  const alt = sprintf(getText('Image of %(heading)s'), { heading });

  const {
    width,
    height,
    fit,
    quality,
    borderRadius,
    qaId,
    marginBottom,
    oneByOneRatio,
  } = tileGridTilePropsByVariant[variant];

  const isTabbing = useTabContext();

  return (
    <TileGridBlockTileButton id={id} $isTabbing={isTabbing} onClick={onClick}>
      <TileGridBlockTileImageContainer
        style={{
          marginBottom,
          aspectRatio: oneByOneRatio ? '1' : undefined,
          borderRadius,
          width,
          height: oneByOneRatio ? undefined : height,
        }}
      >
        <FilestackImage
          data={imageData}
          data-qa-id={qaId}
          alt={alt}
          width={width}
          height={height}
          fit={fit}
          quality={quality}
          objectFit="cover"
          aspectRatio={oneByOneRatio ? { width: 1, height: 1 } : undefined}
        />
      </TileGridBlockTileImageContainer>

      <TileGridBlockTileHeading>{heading}</TileGridBlockTileHeading>

      {subHeading && (
        <TileGridBlockTileSubHeading>{subHeading}</TileGridBlockTileSubHeading>
      )}
    </TileGridBlockTileButton>
  );
}
